import 'es6-promise/auto';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import analytics from './plugins/analytics';

// must be imported here at global level
import 'cleave.js/dist/addons/cleave-phone.us';

analytics(router);

Vue.config.productionTip = false;

new Vue({
    router,
    render: (h) => h(App),
}).$mount('#app');
